// app/frontend/components/Users/ManagedArtists.tsx
import React from 'react';
import { Container, Group, Title, Text, Card, Button, Avatar, Stack, Badge } from '@mantine/core';
import { Link } from '@inertiajs/react';

interface Artist {
  id: number;
  name: string;
  avatar_url: string | null;
  portal_enabled: boolean;
  stripe_connected: boolean;
}

interface ManagedArtistsProps {
  artists: Artist[];
  claimedArtist?: Artist;
}

const ManagedArtists: React.FC<ManagedArtistsProps> = ({ artists, claimedArtist }) => {
  return (
    <Container mb="4rem">
      <Card shadow="sm" p="lg" radius="sm" style={{ marginBottom: '1rem', backgroundColor: '#17171770' }}>
        <Group justify="space-between" align="center">
          <div>
            <Title order={3} className="text-white">
              Artists You Manage
            </Title>
            <Text size="sm" c="dimmed">
              Manage your artist profiles and portals here!
            </Text>
          </div>
          <Button component={Link} href="/suggest_artist" variant="filled">
            Add New Artist
          </Button>
        </Group>
      </Card>

      {/* Claimed Artist Card */}
      {claimedArtist && (
        <Card shadow="sm" p="lg" radius="sm" style={{ marginBottom: '1rem', backgroundColor: '#17171770' }}>
          <Group align="center" gap="xl">
            <Avatar src={claimedArtist.avatar_url || undefined} size={80} radius="50%" />
            <div>
              <Text size="sm" c="dimmed">
                Your Claimed Artist is:
              </Text>
              <Title order={4} c="white" className="rubik">
                {claimedArtist.name}
              </Title>
            </div>
          </Group>

          <Stack mt="md" gap="sm">
            <Button component={Link} href={`/artists/${claimedArtist.id}/edit`} variant="light">
              Edit Artist Profile
            </Button>

            <Button component={Link} href="#" variant="filled" disabled className="clear-button">
              {claimedArtist.portal_enabled ? 'Manage Booking Portal' : 'Enable Booking Portal'}
            </Button>

            <Button component="a" className="clear-button" href="#" variant="outline" disabled>
              {claimedArtist.stripe_connected ? 'Manage Stripe' : 'Connect to Stripe'}
            </Button>

            <Button component={Link} className="clear-button" href="#" variant="outline" disabled>
              Manage Private Lessons
            </Button>
          </Stack>
        </Card>
      )}

      {/* All Artists List with pagination stub */}
      {artists.length > 0 && (
        <Card shadow="sm" p="lg" radius="sm" style={{ backgroundColor: '#75757550' }}>
          <Group justify="space-between" mb="md">
            <Title order={4} className="text-white">
              All Your Artists{' '}
            </Title>
            <Badge color="gray" size="xl" radius="sm" variant="filled">
              {artists.length}
            </Badge>
          </Group>

          <Stack gap="md">
            {artists.map((artist) => (
              <Card key={artist.id} shadow="xs" p="md" radius="sm" style={{ backgroundColor: '#17171770' }}>
                <Group align="center" justify="space-between">
                  <Group align="center">
                    <Avatar src={artist.avatar_url || undefined} size={40} radius="50%" />
                    <Text className="text-white">{artist.name}</Text>
                  </Group>
                  <Button component={Link} href={`/artists/${artist.id}/edit`} size="xs" variant="filled">
                    Manage
                  </Button>
                </Group>
              </Card>
            ))}
          </Stack>
        </Card>
      )}
    </Container>
  );
};

export default ManagedArtists;
